<template>
    <v-app>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" light app color="primary">
        <Link href="/">
            <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                    
                <img
                    
                    src="/img/lightlogos/apple-touch-icon.png"
                    contain
                    class="logo"
                    @click.stop=""
                    v-bind="attrs"
                    v-on="on"
                    height="40"
                    width="40"
                />
                </template>
                <span>Home</span>
            </v-tooltip>
        </Link>
        
    <v-spacer />
    <Link href="/search/job" as="button" v-if="!isUser('course_provider')">
        <v-btn color="white" text>
            <span>Jobs</span>
        </v-btn>
    </Link>
    <Link href="/search/course" as="button" v-if="!isUser('employer')">
        <v-btn color="white" text>
            <span>Courses</span>
        </v-btn>
    </Link>
    
    <Link href="/events" as="button" v-if="!isUser('course_provider') && !isUser('employer')">
        <v-btn color="white" text>
            <span>Events</span>
        </v-btn>
    </Link>
    <template v-if="auth.user">
        <Link href="/admin" v-if="isUser('admin')" as="button">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs"
                v-on="on">
                <v-icon color="white">mdi-cog-outline</v-icon>
                </v-btn>
                </template>
                <span>Admin</span>
            </v-tooltip>
        </Link>
        <Link href="/employer/dashboard" v-if="isUser('employer')">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs"
                v-on="on" color="white" text>
                <v-icon color="white">mdi-view-dashboard</v-icon> My Jobs
                </v-btn>
                </template>
                <span>Dashboard</span>
            </v-tooltip>
        </Link>
        
        <Link href="/provider/dashboard" v-if="isUser('course_provider')">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs"
                v-on="on" color="white" text>
                <v-icon color="white">mdi-view-dashboard</v-icon> My Courses
                </v-btn>
                </template>
                <span>Dashboard</span>
            </v-tooltip>
        </Link>
        <Link href="/dashboard" v-if="isUser('user')" as="button">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-on="on" v-bind="attrs">
                        <v-icon>mdi-account</v-icon>
                    </v-btn>
                </template> 
                <span>Profile</span>
            </v-tooltip>
        </Link>

        <Link href="/logout" method="delete" as="button">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-on="on" v-bind="attrs">
                        <v-icon>mdi-logout</v-icon>
                        
                    </v-btn>
                </template>
                <span >Logout</span>
            </v-tooltip>
                
        </Link>
        
        
    </template>
    <template v-else>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon @click="loginDialog = !loginDialog" v-on="on" v-bind="attrs">
                    <v-icon>mdi-account</v-icon>
                </v-btn>
            </template>
            <span >Login</span>
        </v-tooltip>    
    </template>
    
    </v-app-bar>
    <v-dialog v-model="loginDialog" content-class="loginDialog" ref="loginDialog">
        <LoginRegister @toggleDialog="toggleDialog()" @closeLoginDialog="loginDialog=false;timedLoginRequest()"  :redirectHome="false" :baseurl="baseurl"></LoginRegister>
    </v-dialog>
    <v-main @toggleComponentLogin="toggleComponentLogin($event)">
    <v-container fluid style="height:100%;padding:0px !important;">
        
        
            <slot />
    </v-container>
    </v-main>
    <Footer></Footer>
    <CookieConsent style="position:fixed;bottom:0px;background:white"></CookieConsent>
</v-app>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import LoginRegister from '@/Shared/LoginRegister'
import FlashMessages from '@/Shared/FlashMessages'
import Footer from '@/Shared/Footer'
import CookieConsent from '@/Shared/CookieConsent'

export default {
  components: {
    FlashMessages,
    Link,
    LoginRegister,
    Footer,
    CookieConsent
  },
  props: {
    auth: Object,
    state: String,
    baseurl: String,
    loggedIn: Boolean,
  },
  data() {
    return {
      loginDialog: false,
      action: null,
      toggled: false,
    }
  },
  mounted() {
    let vm = this;
    if (!this.auth || !this.auth.user)
    {
        this.setCookie('ltoken',0,-1,'','/');
        setTimeout(function tog() {
            if (!vm.loginDialog && (!vm.auth || !vm.auth.user))
                vm.toggleDialog();
        }, 1000*60);
    }
    else
    {
        this.setCookie('ltoken',1, 365, '', '/')
    }
  },
  methods: {
    timedLoginRequest() {
        let vm = this;
        setTimeout(function tog() {
            if (!vm.loginDialog && !vm.auth && !vm.auth.user)
                vm.toggleDialog();
        }, 1000*180);
    },
    toggleComponentLogin(e)
    {
        this.toggleDialog();
        this.action = e;
    },
    toggleDialog() {
        this.loginDialog = !this.loginDialog

        this.action = null;
        //if (!this.logindialog) this.$refs.loginDialog.hideOverlay()
    },
    isLoggedIn() {
        if (this.auth && this.auth.user && this.auth.user.roles)
            return true;
        else
            return false;
    },
    isUser(r) {
        if (this.auth && this.auth.user && this.auth.user.roles && this.auth.user.roles.includes(r))
            return true;
        else
            return false;
    },
    getCookie(name) {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        return parts.length !== 2 ?
        undefined :
        parts.pop().split(';').shift()
    },
    setCookie(name, value, expiryDays, domain, path) {
        const exdate = new Date()
        exdate.setDate(exdate.getDate() + (expiryDays || 365))
        const cookie = [
        `${name}=${value}`,
        `expires=${exdate.toUTCString()}`,
        `path=${(path || '/')}`
        ]
        if (domain) {
        cookie.push(`domain=${domain}`)
        }
        document.cookie = cookie.join(';')
    }
    
  }
}
</script>